import React from 'react';
import { Message } from '../types';
import { formatDistanceToNow } from 'date-fns';

interface ChatMessageProps {
  message: Message;
  assistantAvatar?: string;
  assistantName?: string;
  primaryColor?: string;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  message,
  assistantAvatar,
  assistantName = 'John',
  primaryColor = '#3b82f6',
}) => {
  const isUser = message.role === 'user';
  const formattedTime = formatDistanceToNow(new Date(message.timestamp), { addSuffix: true });
  
  if (isUser) {
    return (
      <div className="skit-ai-llm-flex skit-ai-llm-justify-end skit-ai-llm-mb-6">
        <div 
          className="skit-ai-llm-max-w-[80%] skit-ai-llm-p-4 skit-ai-llm-rounded-2xl skit-ai-llm-rounded-br-md skit-ai-llm-text-[14px]"
          style={{ 
            backgroundColor: primaryColor,
            color: 'white',
            whiteSpace: 'pre-wrap'
          }}
        >
          {message.content}
        </div>
      </div>
    );
  }

  return (
    <div className="skit-ai-llm-mb-6">
      <div 
        className="skit-ai-llm-max-w-[80%] skit-ai-llm-p-4 skit-ai-llm-rounded-xl skit-ai-llm-border skit-ai-llm-text-[14px]"
        style={{ 
          backgroundColor: '#FAFAFA',
          borderColor: '#D9D9D9'
        }}
      >
        <div className="skit-ai-llm-flex skit-ai-llm-items-center skit-ai-llm-gap-2 skit-ai-llm-mb-1">
          <div className="skit-ai-llm-w-10 skit-ai-llm-h-10 skit-ai-llm-rounded-full skit-ai-llm-overflow-hidden">
            {assistantAvatar ? (
              <img
                src={assistantAvatar}
                alt={assistantName}
                className="skit-ai-llm-w-full skit-ai-llm-h-full skit-ai-llm-object-cover"
              />
            ) : (
              <div className="skit-ai-llm-w-full skit-ai-llm-h-full skit-ai-llm-bg-gray-300 skit-ai-llm-flex skit-ai-llm-items-center skit-ai-llm-justify-center skit-ai-llm-text-gray-600">
                {assistantName?.charAt(0).toUpperCase() || "J"}
              </div>
            )}
          </div>
          <div className="skit-ai-llm-font-medium">
            {assistantName} • {formattedTime}
          </div>
        </div>

        {message.isLoading ? (
          <div className="skit-ai-llm-flex skit-ai-llm-space-x-1 skit-ai-llm-p-5">
            <div className="skit-ai-llm-w-2 skit-ai-llm-h-2 skit-ai-llm-bg-gray-400 skit-ai-llm-rounded-full skit-ai-llm-animate-bounce"></div>
            <div
              className="skit-ai-llm-w-2 skit-ai-llm-h-2 skit-ai-llm-bg-gray-400 skit-ai-llm-rounded-full skit-ai-llm-animate-bounce"
              style={{ animationDelay: "0.2s" }}
            ></div>
            <div
              className="skit-ai-llm-w-2 skit-ai-llm-h-2 skit-ai-llm-bg-gray-400 skit-ai-llm-rounded-full skit-ai-llm-animate-bounce"
              style={{ animationDelay: "0.4s" }}
            ></div>
          </div>
        ) : (
          <div className="skit-ai-llm-mt-2 skit-ai-llm-text-[#757575]" style={{ whiteSpace: 'pre-wrap' }}>
            {message.content}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
